/**
 * 操作者種別。バックエンド `App\Constant\ActorType` と一致。
 */
export const ACTOR_TYPE = {
  company: 1,
  influencer: 2,
} as const;

export type ActorTypeCode = typeof ACTOR_TYPE[keyof typeof ACTOR_TYPE];
